<div class="empresa-formas-pago">
  <div class="empresa-formas-pago-hero">
    <img [src]="bannerSrc" width="707" alt="Pago Master: sistema de pago online" loading="eager" />
  </div>

  <section class="empresa-formas-pago-block" aria-labelledby="formas-webpay-title">
    <div class="empresa-formas-pago-copy">
      <h3 id="formas-webpay-title" class="empresa-formas-pago-copy__heading-long">- WebPay</h3>
      <p>Paga con tarjetas de crédito y débito de forma segura.</p>
    </div>
    <div class="empresa-formas-pago-transfer__linkify-wrap">
      <img [src]="webpaySrc" alt="WebPay - Pago con tarjetas de crédito y débito" loading="lazy" />
    </div>
  </section>

  <section class="empresa-formas-pago-block empresa-formas-pago-block--transfer"
    aria-labelledby="formas-transfer-title">
    <div class="empresa-formas-pago-copy">
      <h3 id="formas-transfer-title" class="empresa-formas-pago-copy__heading-long">
        - Transferencia vía Linkify
      </h3>
      <p>Transferencias bancarias en un medio de pago confiable.</p>
    </div>
    <div class="empresa-formas-pago-transfer__linkify-wrap">
      <img [src]="linkifySrc" alt="Linkify, transferencias simples" loading="lazy" />
    </div>
  </section>
</div>